import { useEffect, useState } from "react";
import { IDS } from "@/constants/testIds";
import { OWNER } from "@/data/content";
import { ConnectDialog } from "@/components/ConnectDialog";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid={IDS.nav.root}
      className={`fixed top-0 left-0 right-0 z-50 transition-all border-b ${
        scrolled ? "border-border bg-[#0A0A0A]/95 backdrop-blur" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-8 py-4">
        <a href="#top" className="flex items-center gap-2 font-mono-brut font-black text-lg tracking-tighter uppercase">
          <span className="inline-block h-3 w-3 bg-[#E3FF00]"></span>
          {OWNER.name}
        </a>

        <div className="hidden md:flex items-center gap-6 font-jet text-xs uppercase tracking-widest">
          <a data-testid={IDS.nav.linkAbout} href="#about" className="hover:text-[#E3FF00] transition">About</a>
          <a data-testid={IDS.nav.linkProjects} href="#projects" className="hover:text-[#E3FF00] transition">Projects</a>
          <a data-testid={IDS.nav.linkGithub} href="#github" className="hover:text-[#E3FF00] transition">GitHub</a>
          <a data-testid={IDS.nav.linkTestimonials} href="#testimonials" className="hover:text-[#E3FF00] transition">Testimonials</a>
          <a data-testid={IDS.nav.linkConnect} href="#connect" className="hover:text-[#E3FF00] transition">Connect</a>
        </div>

        <ConnectDialog
          triggerTestId={IDS.nav.ctaConnect}
          triggerLabel="Hire Me →"
          triggerClassName="hidden sm:inline-flex items-center px-4 py-2 border border-[#F4F4F0] font-mono-brut text-xs uppercase tracking-widest hover:bg-[#E3FF00] hover:text-[#0A0A0A] hover:border-[#E3FF00] transition"
          source="nav"
        />
      </div>
    </nav>
  );
}
